import * as $ from 'jquery';

const NEXT_PREV_CLASS = 'slick-prev-next';

export default function(event) {
  let $slickTarget = $(event.target);
  let $active = $slickTarget.find('.slick-slide.slick-current');
  let $prev = $active.prev();
  let $next = $active.next();
  let slidesToShow = $slickTarget.find('.slick-slide[aria-hidden="false"]').length;

  //  $slickTarget.find(`.${NEXT_PREV_CLASS}`).removeClass(NEXT_PREV_CLASS);
  $active.addClass(NEXT_PREV_CLASS);

  checkLoop($prev, slidesToShow, false);
  checkLoop($next, slidesToShow, true);
};

let checkLoop = function($checkItem, slidesToShow, next = true) {
  if (next) {
    slidesToShow = slidesToShow * 2;
  }
  let i = 1;

  if ($checkItem.hasClass('slick-slide')) {
    do {
      $checkItem.addClass(NEXT_PREV_CLASS);

      if (i >= slidesToShow) {
        break;
      }

      $checkItem = next ? $checkItem.next() : $checkItem.prev();
      i++;
    } while ($checkItem.hasClass('slick-slide') && i < slidesToShow);
  }
};
